import { IGetComponentTaxonomies } from './types'

export const getComponentTaxonomyVars: IGetComponentTaxonomies = {
  state: {
    in: ['Unpublished', 'Published'],
  },
}
